
<report-filter
showCostCenters='true'
showFacilities='true'
showShiftBlocks='true'
showPeriodEndDateSelection='true'
showViews='true'
defaultPayPeriodsBack=1
reportType='ancillary'
ancillaryType='acuity'
defaultView='Date'
[(defaultFilter)]="filters"
(filterUpdated)="filterUpdated($event)"
[(views)]="views">
</report-filter>

<smt-reasons-for-variance-drilldown-report
  [filtersUpdated]='filterEventsSubject.asObservable()'
  (reasonsForVarianceDataUpdated)='reasonsForVarianceDataUpdated($event)'
  [(reportFilters)]='filters'>
</smt-reasons-for-variance-drilldown-report>
<report-export-button
  [reportFilters]="filters"
  [exportUrl]="'ReasonsForVariance/GetReasonsForVarianceReportExportData'"
  [fileName]="'Activity_ReasonsForVariance_Report'"
  [filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>
<table class="condensed" role="list" *ngIf="reasonsForVarianceData.gridInformation">
  <colgroup>
    <col class="medium-filter-column">
    <col class="medium-filter-column">
    <col class="medium-filter-column">
  </colgroup>
  <thead>
    <th align="left" *ngIf="filters.shouldDisplayViewFilterColumn()">{{filters.ReportView}}</th>
    <th align="left">Date</th>
    <th align="left">Shift Block</th>
    <th align="left">Hours Variance</th>
    <th align="left">Reasons For Variance</th>
    <th align="left">User</th>
    <th align="left">Comments</th>
  </thead>
  <tr *ngFor="let item of reasonsForVarianceData.gridInformation">
    <td *ngIf="filters.shouldDisplayViewFilterColumn()">{{item.viewFilter}}</td>
    <td>{{item.date}}</td>
    <td>{{getShiftBlockDescription(item.startHour, item.endHour)}}</td>
    <td>{{item.hoursVariance}}</td>
    <td>{{item.reasonsForVariance}}</td>
    <td>{{item.user}}</td>
    <td>{{item.comments}}</td>
  </tr>
  </table>
